import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { GymDemo } from "./pages/demos/GymDemo";
import { SalonDemo } from "./pages/demos/SalonDemo";
import { PhotographerDemo } from "./pages/demos/PhotographerDemo";
import { RestaurantDemo } from "./pages/demos/RestaurantDemo";
import { RealEstateDemo } from "./pages/demos/RealEstateDemo";
import { AdminBookings } from "./pages/AdminBookings";
import { ProjectPage } from "./pages/Project";
import { Portfolio } from "./pages/Portfolio";
import { TaraPrivacyPolicy } from "./pages/TaraPrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:id" element={<ProjectPage />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/demo/gym" element={<GymDemo />} />
          <Route path="/demo/salon" element={<SalonDemo />} />
          <Route path="/demo/photographer" element={<PhotographerDemo />} />
          <Route path="/demo/restaurant" element={<RestaurantDemo />} />
          <Route path="/demo/real-estate" element={<RealEstateDemo />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/tara/privacy-policy" element={<TaraPrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
